/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { State } from '@gh/common-shared';
import { FocusedCell } from '@gh/core-ui-grid';
import { isNil } from 'lodash';
import { Observable } from 'rxjs';
import { HpeTop, isHpeContractPriceTop } from '../../../resources/hpe-details.model';
import { HpeCommandService } from '../hpe-command.service';
import {
  HpeDetailsState,
  HpeFocusedTable,
  queryHpeEditable,
  queryHpeFocusedCell,
  queryHpeProcessChangesAsap,
  queryHpeTops,
} from '../hpe-details.state';
import { HpeDetailsTopGridDefinition } from './hpe-details-top-grid-definition.service';

@Component({
  selector: 'gh-hpe-details-top-list',
  template: require('./hpe-details-top-list.component.html'),
  styles: [require('./hpe-details-top-list.component.scss')],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [HpeDetailsTopGridDefinition],
})
export class HpeDetailsTopListComponent implements OnInit {
  editable: boolean = true;
  tops$: Observable<HpeTop[]>;
  focusedCell$: Observable<Maybe<FocusedCell>>;
  processChangesAsap$: Observable<boolean>;

  constructor(public gridDefinition: HpeDetailsTopGridDefinition,
              private state: State<HpeDetailsState>,
              private commands: HpeCommandService) {

  }

  ngOnInit(): void {
    this.tops$ = this.state.select(queryHpeTops);
    this.focusedCell$ = this.state.select(queryHpeFocusedCell, HpeFocusedTable.TopList);
    this.editable = this.state.project(queryHpeEditable);
    this.processChangesAsap$ = this.state.select(queryHpeProcessChangesAsap);
  }

  canBeDeleted(top: HpeTop): boolean {
    if (isHpeContractPriceTop(top)) {
      return false;
    }

    return isNil(top.count) || top.count === 0;
  }

  onOpenGto(): void {
    this.commands.openGto();
  }

  onViewInfo(top: HpeTop): void {
    this.commands.topViewInfo(top);
  }

  onDelete(top: HpeTop): void {
    this.commands.topRemove(top);
  }

  onFocusedCellChanged(): void {
    this.commands.resetFocusedCell();
  }
}
